import React, { useEffect } from 'react'
import { NoDataIcon, PageHeader } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import styled from 'styled-components'
import { TitleContainer } from '../../../Logs/LogScreen/components/IncidentLogScreens/components/display/commonStyledComponents'
import GoalReportsSection from './components/GoalReportsSection'
import { useGoalsReportList } from './hooks/useGoalsReportList'
import useFilterParamsGeneric from '../../../../hooks/useFilterParamsGeneric'
import { GoalFilters, SetFilterParams } from './components/GoalFilters'
import { goalReportsConstants } from '../../../../locale/goalReports'
import { FilterValues } from './types'
import { Spinner } from '../../../../components/generic'
import { EmptyState } from '@lmc/ui-kit'
import { useRouter } from '../../../../hooks/useRouter'

export const GoalsManagement = () => {
  const { t } = useTranslation(NAMESPACE.GOAL_REPORTS)
  const { location } = useRouter()

  const initialFiltersValue = {
    residents: [],
    goalStatuses: [],
    reviewStatuses: [],
  }
  const { filterParamsGeneric, setFilterParams } =
    useFilterParamsGeneric(initialFiltersValue)

  useEffect(() => {
    if (location?.state?.reviewStatus) {
      setFilterParams((prev) => ({
        ...prev,
        reviewStatuses: location.state.reviewStatus,
      }))
    }
  }, [location?.state])

  const filterParams = filterParamsGeneric as FilterValues

  const { data, isLoading } = useGoalsReportList(filterParams as FilterValues)

  return (
    <MainContainer>
      <PageHeader
        title={
          <TitleContainer>
            {t(goalReportsConstants.GOAL_MANAGEMENT)}
          </TitleContainer>
        }
      />
      <GoalFilters
        filterParams={filterParams}
        setFilterParams={setFilterParams as SetFilterParams}
      />
      {isLoading ? (
        <Spinner />
      ) : (
        <SectionsContainer>
          {data?.length ? (
            data?.map((residentGoalData) => {
              return (
                <GoalReportsSection
                  data={residentGoalData}
                  key={residentGoalData?.id}
                />
              )
            })
          ) : (
            <EmptyState
              title={t(goalReportsConstants.EMPTY_STATE)}
              icon={<NoDataIcon />}
            />
          )}
        </SectionsContainer>
      )}
    </MainContainer>
  )
}

const MainContainer = styled.div`
  max-width: 1080px;
  margin: 24px;
  display: flex;
  gap: 24px;
  flex-direction: column;
`
const SectionsContainer = styled.div`
  display: flex;
  gap: 10px;
  flex: 1;
  flex-direction: column;
`
export default GoalsManagement
